/**
 * Portal Entry Point for Portal-CrudManager
 *
 * This file registers all pages and sidebar components with the portal system.
 * It is imported by the portal's virtual:portal-entries module.
 */

import { registerPage } from "@ja/portal/pageRegistry";
import { registerSidebarComponent } from "@ja/portal/sidebarComponents";

import SidebarRecentItems from "./components/SidebarRecentItems.vue";
import { registerBlockComponent } from "./services/componentRegistry";

// Register pages with the portal
registerPage(
    "portal-crudmanager",
    "pages/Dashboard",
    () => import("./pages/Dashboard.vue")
);
registerPage(
    "portal-crudmanager",
    "pages/Lister",
    () => import("./pages/Lister.vue")
);
registerPage(
    "portal-crudmanager",
    "pages/Creator",
    () => import("./pages/Creator.vue")
);
registerPage(
    "portal-crudmanager",
    "pages/Editor",
    () => import("./pages/Editor.vue")
);
registerPage(
    "portal-crudmanager",
    "pages/Viewer",
    () => import("./pages/Viewer.vue")
);

// Register sidebar components with the portal
registerSidebarComponent("SidebarRecentItems", SidebarRecentItems);

// Register custom block components
registerBlockComponent(
    "Crud::CommentsBlock",
    () => import("./components/CommentsBlock.vue"),
    "crud"
);
registerBlockComponent(
    "Crud::EquipmentReportDataBlock",
    () => import("./components/EquipmentReportDataBlock.vue"),
    "crud"
);
registerBlockComponent(
    "Crud::ActivityLogBlock",
    () => import("./components/ActivityLogBlock.vue"),
    "crud"
);
